module.exports = __webpack_public_path__ + "img/1.8b254570.png";